import type { Rect, Size } from '@/types/geometry';
import type { ResizeAnchor } from '@/enums/dragKind';

export function computeResizedRect(
  anchor: ResizeAnchor,
  initial: Rect,
  dx: number,
  dy: number,
  minSize: Size,
  maxSize: Size,
): Rect {
  const clampW = (w: number) => Math.max(minSize.width, Math.min(maxSize.width, w));
  const clampH = (h: number) => Math.max(minSize.height, Math.min(maxSize.height, h));

  const affectsLeft = anchor.includes('left');
  const affectsRight = anchor.includes('right');
  const affectsTop = anchor.includes('top');
  const affectsBottom = anchor.includes('bottom');

  let { x, y, width, height } = initial;

  if (affectsRight) width = clampW(initial.width + dx);
  if (affectsBottom) height = clampH(initial.height + dy);

  if (affectsLeft) {
    const newWidth = clampW(initial.width - dx);
    x = initial.x + (initial.width - newWidth);
    width = newWidth;
  }
  if (affectsTop) {
    const newHeight = clampH(initial.height - dy);
    y = initial.y + (initial.height - newHeight);
    height = newHeight;
  }

  return { x, y, width, height };
}
